'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @param app app ID, e.g. "mail"
 * @param key name of the property
 * @param fallback optional parameter to use as default value
 * @throws if the key can't be found
 */
function loadState(app, key, fallback) {
    var elem = document.querySelector("#initial-state-".concat(app, "-").concat(key));
    if (elem === null) {
        if (fallback !== undefined) {
            return fallback;
        }
        throw new Error("Could not find initial state ".concat(key, " of ").concat(app));
    }
    try {
        return JSON.parse(atob(elem.value));
    }
    catch (e) {
        throw new Error("Could not parse initial state ".concat(key, " of ").concat(app));
    }
}

exports.loadState = loadState;
//# sourceMappingURL=index.js.map
